import { render, staticRenderFns } from "./SampleShelfBadge.vue?vue&type=template&id=3e1ecf0d&scoped=true&"
import script from "./SampleShelfBadge.vue?vue&type=script&lang=js&"
export * from "./SampleShelfBadge.vue?vue&type=script&lang=js&"
import style0 from "./SampleShelfBadge.vue?vue&type=style&index=0&id=3e1ecf0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e1ecf0d",
  null
  
)

export default component.exports